import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationComponent } from './configuration.component';
import { ConfigurationRoutingModule } from './configuration-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { MxCommonsModule } from 'mx-commons';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { SharedComponentModule } from 'src/app/shared/components/shared-component.module';
import { SharedPipesModule } from 'src/app/shared/pipes/shared-pipes.module';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { ColorChromeModule } from 'ngx-color/chrome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxFileDropModule } from 'ngx-file-drop';
import { UploadService } from 'src/app/shared/components/upload/upload.service';
import { ConfigurationService } from './configuration.service';
import { EventEmitter } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		ConfigurationRoutingModule,
		TranslateModule,
		MxCommonsModule,
		AngularDualListBoxModule,
		ChartsModule,
		ReactiveFormsModule,
		SharedComponentModule,
		ConfirmationPopoverModule,
		ColorChromeModule,
		TooltipModule.forRoot(),
		ColorPickerModule,
		SharedPipesModule,
		NgxFileDropModule,
		NgSelectModule
	],
	declarations: [ConfigurationComponent],
	providers: [
		ThemeService,
		UploadService,
		EventEmitter,
		ConfigurationService
	]
})
export class ConfigurationModule { }
